import React from 'react';
import SvgExclamationMark from '../../image/exclamation-mark.svg';
import styled from './index._less';

interface IProps {
  text: String
}

export default function  ({ text }: IProps) {

  return (
    <>
      <div className="login-form-validator-message">
        <SvgExclamationMark />
        <span>{ text }</span>
      </div>
      <style jsx>{ styled }</style>
    </>
  )
}
